export default __webpack_public_path__ + "ca76d1e1cf0ae30d210b523283a98b3a.png";